import { makeStyles } from '@material-ui/core/styles';

const useLoginStyles = makeStyles(theme => ({
  Login: {
    alignItems: 'center',
    backgroundColor: theme.palette.logoBackground,
    backgroundImage: 'url(/backgroundImage/loginImage.png)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    color: theme.palette.white,
    display: 'flex',
    height: 'auto',
    justifyContent: 'center',
    minHeight: '100vh',
    position: 'fixed',
    width: '100%',
    '&__container': {
      alignItems: 'center',
      color: theme.palette.white,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100vh',
      maxHeight: 720,
      padding: '5%',
      position: 'relative',
      '&__paper': {
        alignItems: 'center',
        color: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        '&__avatar': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.white,
          margin: theme.spacing(1),
        },
        '&__form': {
          color: theme.palette.white,
          marginTop: theme.spacing(1),
          width: '100%', // Fix IE 11 issue.
          minWidth: 400,
          minHeight: 40,
          '&__checkbox': {
            '&--color': {
              color: `${theme.palette.primary.main} !important`,
            },
          },
          '&__outlined': {
            '&__input': {
              '&:-webkit-autofill': {
                WebkitTextFillColor: theme.palette.white,
              },
            },
            '&--border': {
              borderColor: theme.palette.white,
            },
            '&--color': {
              color: theme.palette.white,
            },
          },
          '&__submit': {
            margin: theme.spacing(3, 0, 2),
          },
          '&--hr': {
            minHeight: 49,
            '&--error': {
              minHeight: 26,
            },
          },
        },
      },
    },
    '&__copyright': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      '&__logo': {
        height: 35,
        margin: '0px 5px',
        width: 35,
      },
    },
    '&__icon': {
      color: theme.palette.white,
      position: 'relative',
      '&__wrapper': {
        color: theme.palette.white,
        cursor: 'pointer',
        fontSize: '1.2rem',
        position: 'absolute',
        right: '40px',
        top: '40px',
      },
    },
    '&__lang': {
      position: 'relative',
      overflow: 'hidden',
      '&__icon': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        transition: 'transform 0.25s ease-out',
      },
      '&__text': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(150%)',
        transition: 'transform 0.25s ease-out',
      },
      '&:hover &__icon': {
        transform: 'translateX(-200%)',
      },
      '&:hover &__text': {
        transform: 'translateX(-50%)',
      },
    },
    '&__loader': {
      display: 'flex',
      alignItems: 'center',
      '&__dot-flashing': {
        position: 'relative',
        top: 2,
        left: 15,
        width: '5px',
        height: '5px',
        borderRadius: '100%',
        backgroundColor: theme.palette.iconDivider,
        color: theme.palette.iconDivider,
        animation: `$dotFlashing 1s infinite linear alternate`,
        animationDelay: '.5s;',
        '&:before': {
          content: '""',
          display: 'inline-block',
          position: 'absolute',
          top: 0,
          left: '-10px',
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: theme.palette.iconDivider,
          color: theme.palette.iconDivider,
          animation: `$dotFlashing 1s infinite alternate`,
          animationDelay: '0s',
        },
        '&:after': {
          content: '""',
          display: 'inline-block',
          position: 'absolute',
          top: 0,
          left: '10px',
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: theme.palette.iconDivider,
          color: theme.palette.iconDivider,
          animation: `$dotFlashing 1s infinite alternate`,
          animationDelay: '1s',
        },
      },
    },
    '&__login-page': {
      '&--padding-bottom': {
        // paddingBottom: '15px',
      },
    },
    '&__message': {
      alignItems: 'center',
      display: 'flex',
      height: 70,
      marginTop: 15,
      padding: 15,
      '&--border': {
        '&--error': {
          border: `3px solid ${theme.palette.error.main}`,
        },
        '&--success': {
          border: `3px solid ${theme.palette.success.main}`,
        },
      },
      '&--hidden': {
        opacity: 0,
        border: `3px`,
      },
    },
    '&--cursor': {
      cursor: 'pointer',
    },
  },
  '@keyframes dotFlashing': {
    '0%': {
      backgroundColor: theme.palette.iconColor,
    },
    '50%': {
      backgroundColor: theme.palette.iconDivider,
    },
    '100%': {
      backgroundColor: theme.palette.white,
    },
  },
}));

export { useLoginStyles };
